import { BasicInput, SelectComponent } from "Common/Components";
import Modal from "Common/Components/Modal";
import { useAddOptions } from "../../hooks";
import { useOptionsMenus } from "../../store";
import { useTranslation } from "react-i18next";
import { getDefaultValueForSelect } from "helpers/functionsHelpers";

export const ModalAddOption = () => {
  const { 
    isOpenModalOption, 
    handleCloseModal, 
    setIsEdit, 
    isEdit, 
    setOption } =
    useOptionsMenus();
  const { t } = useTranslation();
  const { formik, isSubmitOption, listMenus, valueMenu,  viewAppOptions  } = useAddOptions();
  // console.log("\n\nlistMenus modalOPTIONS ", listMenus, "\n\n")
  return (
    <Modal
      show={isOpenModalOption}
      onHide={() => {
        handleCloseModal();
        setOption(null);
        setIsEdit(false);
        formik.resetForm();
      }}
      id="defaultModal"
      modal-center="true"
      className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[1050] flex flex-col transition-all duration-300 ease-in-out"
      dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
    >
      <Modal.Header
        className="flex items-center justify-between p-4 border-b dark:border-zink-300/20"
        closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
      >
        <Modal.Title className="text-16">
          {!!isEdit
            ? t("createOption.edit")
            : t("createOption.addNewOptionBtn")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
        <form
          className="mt-8"
          id="signInForm"
          onSubmit={(event: any) => {
            event.preventDefault();
            formik.handleSubmit();
            return false;
          }}
        >
          <BasicInput
            label={t("createOption.form.labelDescription")}
            placeholder={t("createOption.form.inputDescription")}
            id="description"
            name="description"
            type="text"
            value={formik.values.description || ""}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isError={
              !!(formik.touched.description && formik.errors.description)
            }
            errorMessage={formik.errors.description || ""}
          ></BasicInput>
          <BasicInput
            label={t("createOption.form.labelUrl")}
            placeholder={t("createOption.form.inputUrl")}
            id="url"
            name="url"
            type="text"
            value={formik.values.url || ""}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isError={!!(formik.touched.url && formik.errors.url)}
            errorMessage={formik.errors.url || ""}
          ></BasicInput>
          <div className="mb-3">
            <div className="col-span-6">
              <SelectComponent
                label={t("createOption.form.labelMenu")}
                id="menu_id"
                placeholder={t("createOption.form.selectMenu")}
                options={listMenus}
                isMulti={false}
                onChange={(e) => formik.setFieldValue("menu_id", e.value)}
                onBlur={formik.handleBlur}
                value={valueMenu}
                defaultValue={getDefaultValueForSelect(
                  listMenus,
                  formik.values.menu_id.toString()
                )}
              ></SelectComponent>
            </div>
          </div>
          <div className="mb-3">
            <div className="col-span-6">
              <SelectComponent
                label={t("createOption.form.viewApp")}
                id="viewapp"
                placeholder={t("createOption.form.selectMenu")}
                options={viewAppOptions}
                isMulti={false}
                value={viewAppOptions.find(opt => opt.value === formik.values.viewapp)}
                onChange={(e) => formik.setFieldValue("viewapp", e.value)}
                onBlur={formik.handleBlur}
                isError={Boolean(formik.errors.viewapp) && formik.touched.viewapp}
                errorMessage={formik.errors.viewapp as string}
              />

            </div>
          </div>


          <div className="mt-10">
            <button
              disabled={isSubmitOption}
              type="submit"
              className="w-full flex flex-row justify-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            >
              {!!isEdit
                ? t("createOption.edit")
                : t("createOption.addNewOptionBtn")}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};
